/**
 * Pull a human-readable message out of a failed fetch `Response`.
 */
export async function parseErrorMessage(res: Response): Promise<string | undefined> {
  try {
    const body = await res.json();
    const message = (body as { message?: unknown })?.message;
    if (Array.isArray(message)) return message.join('; ');
    if (typeof message === 'string') return message;
    return undefined;
  } catch {
    return undefined;
  }
}
